<template>
    <div
        class="widget-template-selected-card bg-main-bg w-full rounded-lg border border-ui-lines p-2 lg:p-3 cursor-pointer hover:shadow-focus-outer transition"
    >
        <div class="flex items-center gap-2">
            <div class="flex-center">
                <component
                    :is="templateIconComponent"
                    class="text-secondary-actions w-12"
                />
            </div>
            <div class="px-2 flex-grow max-w-1/2 break-keep font-semibold text-base">
                <span class="">{{ widget.TemplateName }}&nbsp;&nbsp;</span>
                <span
                    v-if="widget.customSetup"
                    class="inline-flex rounded-2xl bg-primary text-white text-xs px-2 py-1"
                >
                    {{ $t('common.custom') }}
                </span>
            </div>
            <div class="flex items-center gap-2">
                <RedesignBaseButton
                    size="small"
                    type="soft"
                    @click="onCustomSetup"
                >
                    {{ $t('common.customSetup') }}
                </RedesignBaseButton>
                <RedesignDropdownMenu
                    :menu-items="menuItems"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IWidgetTemplateListItem } from '@/types/templates'
import { computed } from 'vue'
import { templateIcons } from '@/enum/widgetDataTypes'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import RedesignDropdownMenu from '@/components/RedesignBaseComponents/RedesignDropdownMenu.vue'
import i18n from '@/i18n'

const props = defineProps<{
    widget: IWidgetTemplateListItem
    copyDisabled?: boolean
}>()
const emit = defineEmits([ 'widget:delete', 'widget:reset', 'widget:copy', 'widget:custom-setup' ])

const templateIconComponent = computed(() => {
    const _key = props.widget.DataType?.DataTypeID as keyof typeof templateIcons
    return (_key !== undefined ? templateIcons[_key] : '') || templateIcons.Default
})
const menuItems = computed(() => {
    return [
        {
            icon: 'vc-icon-copy',
            label: String(i18n.t('common.duplicate')),
            itemClasses: 'hover:!text-primary-actions',
            disabled: props.copyDisabled,
            callback: onCopyWidget
        },
        {
            icon: 'vc-icon-reset',
            label: String(i18n.t('common.resetCustom')),
            itemClasses: 'hover:!text-primary-actions',
            disabled: false,
            callback: onResetWidget
        },
        {
            icon: 'vc-icon-recycle-bin',
            label: String(i18n.t('common.delete')),
            itemClasses: 'border-t border-ui-lines !text-destructive-actions hover:!bg-destructive-actions-bg--focus',
            disabled: false,
            callback: onDeleteWidget
        },
    ]
})

/* Methods */
function onDeleteWidget () {
    emit('widget:delete', props.widget)
}

function onResetWidget () {
    emit('widget:reset', props.widget)
}

function onCopyWidget () {
    emit('widget:copy', props.widget)
}

function onCustomSetup () {
    emit('widget:custom-setup', props.widget)
}
</script>
